import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function getDataByCustmerId(customerId) {
  return request({
    url: cmsServerContext + '/rechargeResultPush/list/'+ customerId,
    method: 'get',
  })
}

export function saveOrUpdate(data) {
  return request({
    url: cmsServerContext + '/rechargeResultPush/saveOrUpdate',
    method: 'post',
    data: data
  })
}

export function del(data) {
  return request({
    url: cmsServerContext + '/rechargeResultPush/remove',
    method: 'post',
    data: data
  })
}
